import { Button } from 'react-bootstrap';

const RenderPagination = (pageButtons, offset, setOffset, limit) => {
    const totalPages = pageButtons.length;
    if (totalPages <= 1) return null;

    const currentPage = offset + 1;
    const maxVisibleButtons = 3;
    let startPage, endPage;

    if (totalPages <= maxVisibleButtons) {
      startPage = 1;
      endPage = totalPages;
    } else {
      const halfVisible = Math.floor(maxVisibleButtons / 2);

      if (currentPage <= halfVisible + 1) {
        startPage = 1;
        endPage = maxVisibleButtons;
      } else if (currentPage >= totalPages - halfVisible) {
        startPage = totalPages - maxVisibleButtons + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - halfVisible;
        endPage = currentPage + halfVisible;
      }
    }

    return (
      <div className="d-flex justify-content-end mt-3">
        {/* First Page Button */}
        <Button
          variant="outline-primary"
          className="mx-1"
          onClick={() => setOffset(0)}
          disabled={currentPage === 1}
        >
          <i className="bi bi-chevron-double-left"></i>
        </Button>

        {/* Previous Page Button */}
        <Button
          variant="outline-primary"
          className="mx-1"
          onClick={() => setOffset(offset - 1)}
          disabled={currentPage === 1}
        >
          <i className="bi bi-chevron-left"></i>
        </Button>

        {/* Start ellipsis */}
        {startPage > 1 && (
          <>
            <Button
              variant={currentPage === 1 ? 'primary' : 'outline-primary'}
              className="mx-1"
              onClick={() => setOffset(0)}
            >
              1
            </Button>
            {startPage > 2 && <span className="mx-2 my-auto">...</span>}
          </>
        )}

        {/* Page number buttons */}
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
          <Button
            key={page}
            variant={currentPage === page ? 'primary' : 'outline-primary'}
            className="mx-1"
            onClick={() => setOffset(page - 1)}
          >
            {page}
          </Button>
        ))}

        {/* End ellipsis */}
        {endPage < totalPages && (
          <>
            {endPage < totalPages - 1 && <span className="mx-2 my-auto">...</span>}
            <Button
              variant={currentPage === totalPages ? 'primary' : 'outline-primary'}
              className="mx-1"
              onClick={() => setOffset(totalPages - 1)}
            >
              {totalPages}
            </Button>
          </>
        )}

        {/* Next Page Button */}
        <Button
          variant="outline-primary"
          className="mx-1"
          onClick={() => setOffset(offset + 1)}
          disabled={currentPage === totalPages}
        >
          <i className="bi bi-chevron-right"></i>
        </Button>

        {/* Last Page Button */}
        <Button
          variant="outline-primary"
          className="mx-1"
          onClick={() => setOffset(totalPages - 1)}
          disabled={currentPage === totalPages}
        >
          <i className="bi bi-chevron-double-right"></i>
        </Button>
      </div>
    );
  };


  export default RenderPagination;